import { memo } from 'react';

import { ShareDesignImageButton } from '~/components/ShareModal/components/ShareDesignImageButton';
import { useCreateShowcaseDesign } from '~/components/ShowcaseModal/CreateShowcaseDesignProvider';

/**
 * Cover-image picker (`coverImage` write), bound to the design context.
 *
 * Unlike the rest of the Design tab, the whole cover feature — image, width and fade — is available
 * on every plan, so this row reads no plan gate. It still reads
 * `isLoading` — the other half of the `brandingDisabled` gate it used to share with the logo — so
 * the picker can't be opened before there is a draft to write into.
 */
export const CreateShowcaseDesignCoverButton = memo(() => {
  const { coverSrc, isLoading, handleClearCover, handleSelectCover } = useCreateShowcaseDesign();

  return (
    // No brand-kit `options` on the cover: `CoverImageInput` requires assetId + versionId, but
    // brand context values carry at most an assetId — pending a backend `contextSource` (or
    // versionId-less) cover shape.
    <ShareDesignImageButton
      data-testid="CREATE_COLLECTION_LINK_DESIGN_COVER_ROW"
      disabled={isLoading}
      emptyLabel="Choose cover"
      imageSrc={coverSrc}
      onClear={handleClearCover}
      onSelect={handleSelectCover}
      selectModalConfirmLabel="Use as cover"
      selectModalTitle="Select a cover image"
      selectTestId="CREATE_COLLECTION_LINK_DESIGN_COVER_SELECT"
      showUpsell={false}
    />
  );
});

CreateShowcaseDesignCoverButton.displayName = 'CreateShowcaseDesignCoverButton';
